import { Component, Input } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';

@Component({
  selector: '[app-tr-balance]',
  template: `
    <td class="text-start">{{balance?.unit.unit_name}} {{balance?.settlement?.name}}</td>
    <td class="text-center">{{balance?.settlement?.address}} {{settlement?.settlement?.city}}</td>
    <td class="text-center">{{balance.amount | currency: 'USD'}}</td>
  `,
  styles: ``
})
export class TrBalanceComponent {
  @Input() balance: any;
  
  settlement: any = {};
  unit: any = {};

  constructor(
    private store: SettlementsService,
  ) { }

  ngOnInit(): void {
    // console.log("settlement ===> ", this.settlement);
    // this.store.getUnitSettlement(this.balance.unit_id).subscribe((settlement: any) => {
      // this.settlement = settlement;
    // });
    // this.loadData();
  }

  loadData() {
    this.store.getUnit(this.balance.unit_id).subscribe((data: any) => {
      console.log("unit => ", data);
      this.unit = data;
    });
  }
}
